module.exports = __webpack_public_path__ + "static/media/EOC.c78d5fab.png";